import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SimpleLabel from "../Label";
import { Theme } from "@mui/material";

interface CustomAccordionProps {
  title: string;
  info: string;
}
export default function CustomAccordion({ title, info }: CustomAccordionProps) {
  return (
    <Accordion defaultExpanded sx={styles.root}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <SimpleLabel fontWeight={700} title={title} width={"100%"} />
      </AccordionSummary>
      <AccordionDetails>{info}</AccordionDetails>
    </Accordion>
  );
}

const styles = {
  root: (theme: Theme) => ({
    padding: theme.spacing(1),

    width: "100%",

    [theme.breakpoints.up("xl")]: {
      width: "50%"
    }
  })
};
